import { DATE_FORMAT } from 'src/utils/constants';
import { parseInStoredTimezone } from 'src/utils/timezoneUtils';

export const getDraftTransactionDateRange = ({
  isExternal,
  appliedDateRange,
  now
}) => {
  const defaultStartDateTime = isExternal ? null : now.clone().subtract(1, 'hour');
  const defaultEndDateTime = isExternal ? null : now;

  return {
    start: appliedDateRange.start
      ? parseInStoredTimezone(appliedDateRange.start, DATE_FORMAT.unixDateTime)
      : defaultStartDateTime,
    end: appliedDateRange.end
      ? parseInStoredTimezone(appliedDateRange.end, DATE_FORMAT.unixDateTime)
      : defaultEndDateTime
  };
};

const getActiveTransactionFilters = ({
  isExternal,
  isIssued,
  site,
  tank,
  start,
  end,
  vehicle
}) => {
  const filters = [];
  if (site && site !== 'all') filters.push({ key: 'site', label: 'Site', value: site });
  if (isIssued && tank && tank !== 'all') filters.push({ key: 'tank', label: 'Tank', value: tank });
  if (start || end) filters.push({ key: 'date', label: 'Date', value: start && end ? `${start} - ${end}` : start || end });
  if (isExternal && vehicle) filters.push({ key: 'vehicle', label: 'Vehicle', value: vehicle });
  return filters;
};

export default getActiveTransactionFilters;
